// @author jonathan.ronsten@svenskaspel.se

import type { ClientErrorCode } from './constants.js';

export type ClientErrorDetails = Readonly<{
  title: string;
  message: string;
}>;
/* eslint complexity: ["error", {"max": 45}] */

/**
 * Get error details for client error code.
 *
 * @param clientCode The client error code provided.
 * @returns The error details for client error.
 */
export function getClientErrorDetails(clientCode: ClientErrorCode): ClientErrorDetails {
  switch (clientCode) {
    case 'GENERIC':
      return {
        title: 'Tekniskt fel',
        message: 'Något gick fel vid betalningen, försök igen om en liten stund.',
      };
    case 'NOT_PAYABLE':
    case 'NOT_WAGER':
      return {
        title: 'Tekniskt fel',
        message: 'Något gick fel vid betalningen.',
      };
    case 'NOT_ENOUGH_MONEY':
      return {
        title: 'För lite pengar',
        message: 'Ditt spelsaldo har inte tillräckligt med pengar.',
      };
    case 'NOT_ENOUGH_DATA':
    case 'NOT_AUTHENTICATED':
    case 'PAYMENT_REQUEST_FAILURE':
    case 'PAYMENT_FETCH_FAILURE':
    case 'BACKEND_ERROR':
    case 'BAD_RESULT':
    case 'BAD_BET':
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen, vänligen försök igen senare.',
      };
    case 'CANCEL_PAYMENT_FAILURE':
      return {
        title: 'Spelet kunde inte annulleras',
        message: 'Något gick fel vid annullering, vänligen försök igen senare.',
      };
    case 'CANCELATION_TIME_EXCEEDED':
      return {
        title: 'Spelet kunde inte annulleras',
        message: 'Det är längre än 30 min sen du lade detta spel.',
      };
    case 'CANCELATION_STOPPED':
      return {
        title: 'Annulleringar är stoppade på denna omgång.',
        message: 'Spelet kunde inte annulleras',
      };
    case 'CANCELATION_RETAILER_NOT_POSSIBLE':
      return {
        title: 'Ombudsspel kan inte annulleras på nätet',
        message: 'Du behöver gå till ombudet där spelet lades och annullera det under samma dag. Ta med ditt kvitto.',
      };
    case 'IMPOSSIBLE_ROWS':
      return {
        title: 'Omöjlig spelkombination',
        message: 'Spelet gick inte att betala på grund av att spelkombinationen inte är möjlig att vinna på.<br />',
      };
    case 'USER_HAS_EXCLUSION':
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen.',
      };
    case 'BAD_DRAW':
      return {
        title: 'Stängt för spel',
        message: 'Spelomgången går inte att spela på just nu.',
      };
    case 'CUSTOMER_LIMIT':
      return {
        title: 'Du har överskridit en gräns',
        message: 'Något gick fel vid betalningen, du har överskridit en gräns.',
      };
    case 'TIME_LIMIT':
      return {
        title: 'Du har nått din tidsgräns',
        message: 'När du nått din tidsgräns kan du inte betala för spel på Sport & Casino.',
      };
    case 'PLAYER_PAUSED':
      return {
        title: 'Ditt konto är spärrat',
        message: 'Kontakta kundservice för mer information.',
      };
    case 'AMOUNT_LIMIT':
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta totala insats på omgången har överskridits.',
      };
    case 'DAILY_AMOUNT_LIMIT':
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta totala dagliga insats på denna produkt har överskridits.',
      };
    case 'ROW_LIMIT':
      return {
        title: 'Du har överskridit en gräns',
        message: 'Högsta antalet rader på denna omgång har överskridits.',
      };
    case 'COMPETITION_ERROR':
      return {
        title: 'Något gick fel',
        message: 'Det går tyvärr inte att spela på tävlingen just nu.',
      };
    case 'INVALID_PARAM':
    case 'OPS_ACCOUNT_NOT_REACHABLE':
    case 'TECHNICAL_ERROR':
      return {
        title: 'Något gick fel vid betalningen, försök igen om en stund',
        message: '',
      };
    case 'MEMBER_NOT_FOUND':
      return {
        title: 'Det gick inte att hitta medlemmen',
        message: '',
      };
    case 'MEMBER_ACTIVE':
      return {
        title: 'Det gick inte att köpa en andel just nu, försök igen om en stund',
        message: '',
      };
    case 'GROUP_ACTIVE':
    case 'ITS_LIMIT_EXCEEDED':
    case 'CONTAINER_NOT_FOUND':
    case 'ACTIVATED_DRAW_NOT_FOUND':
      return {
        title: 'Något gick fel, försök igen om en stund',
        message: '',
      };
    case 'NO_SHARES_AVAILABLE':
      return {
        title: 'Andelarna är slutsålda',
        message: '',
      };
    case 'OPS_INSUFFICIENT_FUNDS':
      return {
        title: 'Ditt saldo är för lågt',
        message: '',
      };
    case 'NO_OPS_REPLY':
    case 'NO_ITS_REPLY':
      return {
        title: 'Tekniskt fel',
        message: 'Vår server svarar inte på grund av ett tekniskt fel.',
      };
    case 'MAX_SHARES_PER_MEMBER_REACHED':
      return {
        title: 'Du har redan köpt max antal andelar',
        message: '',
      };

    case 'MARKETPLACE_WAGER_ALREADY_PAID':
      return {
        title: 'Andelsspelet är redan inlämnat',
        message: 'Du har redan betalat för ditt spel',
      };

    default:
      return {
        title: 'Något gick fel',
        message: 'Något gick fel vid betalningen',
      };
  }
}
